import _ from 'lodash';
import async from 'async';
// import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Button, DialogActions, DialogContent } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/SaveAlt';
import RedoIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';

import AuthUserContainer from '../../../../../containers/AuthUser';
import ResourceContainer from '../../../../../containers/Resource';
import Transition from '../../../../../components/dialogs/Transition';
import { generalStyles } from '../../util';
import { dialogStyles } from '../dialogStyles';
import MobileDeliveryDialogSavePopup from '../MobileDeliveryDialogSavePopup';
import MobileDeliveryScanSaveConfirmationDialog from '../MobileDeliveryScanSaveConfirmationDialog';

const styles = () => {
	return {
		...generalStyles,
		...dialogStyles,
		dialogSubmitButton: {
			...dialogStyles.dialogSubmitButton,
			marginTop: 0,
			minWidth: '30%',
		},
		dialogRedoButton: {
			...dialogStyles.dialogSecondaryButton,
			marginTop: 0,
			minWidth: '30%',
		},
		dialogCloseButton: {
			...dialogStyles.dialogCloseButton,
			marginTop: 0,
			minWidth: '30%',
		},
	};
};

class MobileSaveScanDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isSaving: false,
			hasSaved: false,
			isAreYouSureDialogOpen: false,
		};
	}

	componentDidUpdate(prevProps, prevState, snapShot) {
		// on open kick off the timer
		if (!prevProps.open && this.props.open) {
			this.setState({
				isSaving: false,
				hasSaved: false,
			});
		}
	}

	openAreYouSureDialog = () => {
		this.setState({
			isAreYouSureDialogOpen: true,
		});
	};

	handleAreYouSureClose = () => {
		this.setState({
			isAreYouSureDialogOpen: false,
		});
	};

	handleAreYouSureCloseAllDialogs = () => {
		this.handleAreYouSureClose();
		this.props.onCloseAllDialogs();
	};

	handleSubmit = () => {
		//- Save teh resource
		const { addResource, showErrors, setBolResource, jpegForUpload } = this.props;
		if (!jpegForUpload) {
			return showErrors([`Missing photo for upload`]);
		}

		this.setState({
			isSaving: true,
			hasSavingSuccess: false,
			hasSavingError: false,
			savingError: null,
		});

		async.waterfall(
			[
				(callback) => {
					addResource({
						params: {
							base64String: jpegForUpload,
						},
						callback,
					});
				},
			],
			(err, r) => {
				this.setState({ isSaving: false });
				if (err) {
					return this.setState({
						//						jpegForUpload: undefined,
						isSaving: false,
						hasSavingSuccess: false,
						hasSavingError: true,
						savingError: err,
					});
				}
				//	const resourceId = _.get(r, 'resourceIds.0');
				const resource = _.get(r, 'collections.resourceCollection.0');

				if (!resource) {
					console.error('Missing resource', r);
					return showErrors(['Could not get resource back from server']);
				}

				this.setState({
					//		jpegForUpload: undefined,
					hasSaved: true,
					isSaving: false,
					hasSavingSuccess: true,
					hasSavingError: false,
				});

				setTimeout(() => {
					this.setState({
						hasSavingSuccess: false,
					});
				}, 3000);
				setBolResource(resource);
			}
		);
	};

	handleClose = () => {
		if (!this.state.hasSaved) {
			this.openAreYouSureDialog();
		} else {
			this.props.onCloseAllDialogs();
		}
	};

	render() {
		const { open, classes, jpegForUpload, hideRetake } = this.props;
		const { isSaving, hasSavingSuccess, hasSavingError, savingError, hasSaved } = this.state;

		return (
			<>
				<Dialog
					open={open}
					TransitionComponent={Transition}
					onClose={this.props.onClose}
					fullWidth={true}
					fullScreen={true}
					maxWidth={'lg'}
					classes={{ scrollPaper: classes.dialogRoot }}
				>
					<DialogContent
						dividers={true}
						style={{
							position: 'relative',
							padding: 0,
							border: 0,
							height: '100%',
							overflow: 'hidden',
						}}
					>
						<div
							style={{
								width: '100%',
								height: '100%',
								zIndex: 10,
								position: 'relative',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								background: '#111',
							}}
						>
							<img
								alt="scan"
								src={jpegForUpload}
								style={{
									width: 'auto',
									height: '100%',
								}}
							/>
						</div>
					</DialogContent>

					<DialogActions style={{ position: 'relative', backgroundColor: '#f7f7f7' }}>
						<MobileDeliveryDialogSavePopup
							classes={classes}
							isSaving={isSaving}
							hasSavingSuccess={hasSavingSuccess}
							hasSavingError={hasSavingError}
							savingError={savingError}
							savingSuccess={'Upload successful. Click close.'}
						/>

						<div style={{ display: 'flex', width: '100%', padding: '0px 2vw' }}>
							<Button
								variant="contained"
								color="primary"
								aria-label="submitRackDelay"
								className={classes.dialogSubmitButton}
								onClick={this.handleSubmit}
								disabled={isSaving || hasSaved}
							>
								<SaveIcon style={{ paddingRight: 5 }} />
								Save
							</Button>

							{hideRetake ? null : (
								<Button
									variant="outlined"
									color="primary"
									className={classes.dialogRedoButton}
									onClick={this.props.onClose}
									disabled={isSaving || hasSaved}
								>
									<RedoIcon style={{ paddingRight: 5 }} />
									Retake
								</Button>
							)}

							<Button
								variant="outlined"
								className={classes.dialogCloseButton}
								onClick={this.handleClose}
								disabled={isSaving}
							>
								<CloseIcon style={{ paddingRight: 5 }} />
								Close
							</Button>
						</div>
					</DialogActions>
				</Dialog>

				<MobileDeliveryScanSaveConfirmationDialog
					open={this.state.isAreYouSureDialogOpen}
					onClose={this.handleAreYouSureClose}
					onCloseAllDialogs={this.handleAreYouSureCloseAllDialogs}
				/>
			</>
		);
	}
}

MobileSaveScanDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	onCloseAllDialogs: PropTypes.func.isRequired,
	classes: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
	addResource: PropTypes.func.isRequired,
	setBolResource: PropTypes.func.isRequired,
	jpegForUpload: PropTypes.string,
	hideRetake: PropTypes.bool,
};
export default _.flow([withStyles(styles), AuthUserContainer, ResourceContainer])(
	MobileSaveScanDialog
);
